<template>
  <card v-if="attendance" class="attendance-card" :plain="isEmbeddedInModal">
    <slot name="header">
      <h3>{{ title }}</h3>
    </slot>

    <div v-if="showMetAt">
      <h6>Met on {{ attendance.met_on_day }} at {{ attendance.met_at_time }}</h6>
      <h3 class="card-title">
        {{ attendance.met_on_date }}
      </h3>
    </div>
    <p
      v-show="!cancelledTrue"
    >
      Participants in attendance:
      <el-checkbox-group
        v-model="participantsAttended"
        style="margin-top: 10px;"
      >
        <el-checkbox
          v-for="participant in attendance.allParticipants"
          :key="participant.person_id"
          :label="participant.person_id"
          :value="participant.person_id"
          class="participants-checkbox"
          style="color: black; font-weight: bold;"
        >
          {{ participant.name }}
          <!-- Element-UI bug, label value appended to v-model instead of value, which works in el-select -->
        </el-checkbox>
      </el-checkbox-group>
    </p>
    <p
      v-show="cancelledTrue"
      :class="{
        error: validationError
      }"
      style="padding: 10px 0 5px 0;"
    >
      Cancelled because:
      <el-select
        placeholder="Choose reason"
        v-model="cancelReason"
        clearable
        class="select-default cancelled-reason"
      >
        <el-option
          v-for="reason in cancelOptions"
          :key="reason.id"
          :label="reason.name"
          :value="reason.id"
        />
      </el-select>
    </p>
    <p class="error-text">
      {{ validationError }}
    </p>
    <button
      class="btn"
      style="background-color: #409EFF; text-transform: none;"
      @click="validateInput()"
    >
      Submit
    </button>
    <p
      v-show="!cancelledTrue && canCancel"
      @click="cancelledTrue = !cancelledTrue"
      class="clickable-paragraph emphasize-clickable"
    >
      Was bible study cancelled?
    </p>
    <p
      v-show="cancelledTrue"
      @click="cancelledTrue = !cancelledTrue; validationError = null"
      class="clickable-paragraph emphasize-clickable"
    >
      Bible study was not cancelled
    </p>

    <modal
      :show="showAttendanceValidation"
      header-classes="justify-content-center"
      @close="showAttendanceValidation = !showAttendanceValidation"
    >
      <h4 slot="header" class="title">
        Are you sure want to submit an attendance with no attendees?
      </h4>
      <p>
        If bible study was cancelled, click "Was bible study cancelled?"
        at the bottom of the attendance to select cancel options.
      </p>
      <template slot="footer">
        <p-button @click="showAttendanceValidation = !showAttendanceValidation">
          Cancel
        </p-button>
        <p-button class="custom-modal-type" @click="handleSubmit()">
          Yes, I'm sure
        </p-button>
      </template>
    </modal>
  </card>
</template>
<script>
import axios from 'axios';
import {
    mapState
} from 'vuex';
import card from '../../UIComponents/Cards/Card';
import modal from '../../UIComponents/Modal';

export default {
    name: 'BibleStudyAttendance',
    components: {
        modal,
        card
    },
    data() {
        return {
            namespace: 'BibleStudies',
            notSubmitted: 'Submit report',
            cancelReason: null,
            cancelledTrue: false,
            participantsAttended: [],
            validationError: null,
            showAttendanceValidation: false,
        };
    },
    props: {
        attendance: Object,
        canCancel: {
            type: Boolean,
            default: true,
        },
        showMetAt: {
            type: Boolean,
            default: true,
        },
        isEmbeddedInModal: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Not submitted'
        }
    },
    watch: {
        attendance() {
            this.cancelReason = this.attendance.cancelled_reason;
            this.cancelledTrue = (this.attendance.cancelled === true);
            this.participantsAttended = this.attendance.attendedParticipants.map(
                (participant) => participant.person_id
            );
        }
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            cancelOptions: (state) => state.BibleStudies.cancelReasons,
        }),
    },
    methods: {
        handleClose() {
            this.cancelReason = this.attendance.cancelled_reason;
            this.cancelledTrue = (this.attendance.cancelled === true);
            this.participantsAttended = this.attendance.attendedParticipants.map(
                (participant) => participant.person_id
            );
            this.validationError = null;
            this.showAttendanceValidation = false;
        },
        validateInput() {
            switch (this.cancelledTrue) {
            case true:
                if (!this.cancelReason) {
                    this.validationError = 'Please choose a reason for canceling bible study.';
                } else {
                    this.handleSubmit();
                }
                break;
            default:
                if (this.participantsAttended.length === 0 && !this.isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])) {
                    this.showAttendanceValidation = true;
                } else {
                    this.handleSubmit();
                }
                break;
            }
        },
        handleSubmit() {
            this.validationError = null;
            let attendanceData = {};
            const attendedArray = [];
            const unattendedArray = [];
            const unknownArray = [];
            let participantsJson = {};
            let allParticipants = this.attendance.allParticipants.map((x) => x);
            switch (this.cancelledTrue) {
            // If the bible study is cancelled, POST data includes cancel reason
            // and all BSPs in unknown array
            case true:
                switch (allParticipants !== null) {
                case true:
                    allParticipants.forEach((participant) => {
                        unknownArray.push(
                            participant.person_id
                        );
                    });
                    participantsJson = {
                        attended: attendedArray,
                        not_attended: unattendedArray,
                        unknown: unknownArray,
                    };
                    break;
                default:
                    break;
                }
                attendanceData = {
                    bible_study_id: this.attendance.bible_study_id,
                    id: this.attendance.id,
                    cancelled: true,
                    cancel_reason_id: this.cancelReason,
                    participants: JSON.stringify(participantsJson),
                };
                break;
            // Otherwise POST data includes selected BSPs in attended array
            // and unselected BSPs in not_attended array
            default:
                this.participantsAttended.forEach((participant) => {
                    attendedArray.push(participant);
                    // Filter all selected BSPs from allParticipants list
                    // and remaining are all unselected BSPs, which are unattended
                    allParticipants = allParticipants.filter(
                        (x) => x.person_id !== participant
                    );
                });
                allParticipants.forEach((participant) => unattendedArray.push(participant.person_id));
                participantsJson = {
                    attended: attendedArray,
                    not_attended: unattendedArray,
                    unknown: unknownArray,
                };
                attendanceData = {
                    bible_study_id: this.attendance.bible_study_id,
                    id: this.attendance.id,
                    cancelled: false,
                    cancel_reason_id: null,
                    participants: JSON.stringify(participantsJson),
                };
                break;
            }
            if (this.isEmbeddedInModal) {
                this.$emit('returnBSAData', attendanceData);
            } else {
                this.$store.dispatch(`${this.namespace}/updateBibleStudyAttendance`, {
                    attendance_data: attendanceData
                });
            }
        },
    },
};
</script>
<style>
.attendance-card{
  text-align: center;
  margin: 20px 0;
}
.attendance-card h3, h6, h5, p{
  margin: 20px 0;
}
.attendance-card h3{
  font-weight: bold;
}
.el-checkbox__label {
  vertical-align: middle;
}
.emphasize-clickable {
  color: gray;
  text-decoration: underline;
}
.clickable-paragraph:hover {
  cursor: pointer;
  color: #409EFF;
}
.participants-checkbox {
  display: block;
  text-align: left;
  margin-left: 25%;
}
h3 {
  text-transform: uppercase;
}
.error {
  border-left: 5px solid red;
  background-color: lightpink;
  font-weight: bold;
  padding: 0 5px 0 5px;
  margin: 0 0;
}
.error-text{
  color: red;
  font-weight: bold;
  margin: 0 0;
}
.cancelled-reason {
  display: block;
  width: 80%;
  margin: auto;
}
.modal-open {
    overflow: scroll;
}
</style>
